import { useRouter } from 'vue-router';

export default () => {
  const router = useRouter();

  const handleUpgradeButtonClick = () => {
    router.push({ name: 'subscription' });
  };

  return {
    handleUpgradeButtonClick,
  };
};
